import PageProtectedLayout from '../../../../components/Page/PageProtectedLayout';
import OrganHealth from './OrganHealth';
import { useTranslation } from '../../../../language';



export default function OrganHealthWelcome() {

  const { t } = useTranslation();

return (

    <PageProtectedLayout

      headline={t('page_hl_organ_health')}
      headlineFontWeight={500}
      >

    <OrganHealth />
      
    </PageProtectedLayout>

  );
}